import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	BarElement,
	LineElement,
	PointElement,
	ArcElement,
	CategoryScale,
	LinearScale,
	Filler,
} from "chart.js"

ChartJS.register(
	Title,
	Tooltip,
	Legend,
	BarElement,
	LineElement,
	PointElement,
	ArcElement,
	CategoryScale,
	LinearScale,
	Filler
)

export default defineNuxtPlugin(() => {})
